// extracted by mini-css-extract-plugin
module.exports = {"sideBarContainer":"ShopMainContainer_sideBarContainer__riYHF","mainContainer":"ShopMainContainer_mainContainer__7Rl72"};